import { APP_URL } from '@import-io/js-sdk/constants/host-constants';

export const redirectToApp = (url: string | undefined = APP_URL) => {
  if (url?.startsWith('https://')) {
    // Prevent forwarding to javascript:// URLs
    window.location.replace(url);
  }
};
